module.exports = __webpack_public_path__ + "c4edd73347ebadd9603ac70ddbbf353d.png";